<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title> {{title}} </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeView.emit()"><ion-icon name="close-outline"></ion-icon></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true">

  <div *ngIf="!exercises.length && !isLoading">
    <div class="empty-notice-container">
      <ion-card class="ion-text-center">
        <ion-icon class="pt" name="add-circle-outline" size="large"></ion-icon>
        <ion-card-header>
          <ion-card-title>No Existing Exercises</ion-card-title>
        </ion-card-header>
        <ion-card-content>
          <p>It looks like you don't have any exercises to add. Start by creating a new exercise to enrich your workout plan.</p>
          <ion-button class="py" expand="block" (click)="noExercise.emit(); closeView.emit()">Create Exercise</ion-button>
        </ion-card-content>
      </ion-card>
    </div>
  </div>

  <ion-button
    *ngIf="exercises.length"
    class="py px"
    expand="block"
    fill="outline"
    (click)="emitSelectedExercises()"
    >Add Selected Exercises
  </ion-button>

  <div
    class="px"
    *ngIf="exercises.length"
  >
    <app-exercise-filter
      (toggleStatesChange)="handleToggleStatesChange($event)"
    ></app-exercise-filter>
  </div>

  <ion-list class="py" style="margin-bottom: 80px;" *ngIf="!isLoading; else skeleton">
    <ion-item *ngFor="let exercise of getFilteredExercises()">
      <ion-checkbox
        labelPlacement="end"
        (ionChange)="
          updateSelectedExercises(exercise.id, $event.detail.checked)
        "
        [checked]="selectedExercises.has(exercise.id!)"
      >
      <span>{{ exercise.sportName }}</span>
    </ion-checkbox>

    <div slot="end" class="end-item">
      <div class="hashtags">
        <ng-container *ngFor="let muscle of exercise.hashtags">
          <ion-badge
            style="margin: 0 2px"
            *ngIf="muscle | isGroup | async"
            [style.background]="muscle | groupColor | async"
            >{{ muscle }}
          </ion-badge>
        </ng-container>
      </div>
      <ion-thumbnail slot="start" class="custom-thumbnail">
        <app-exercise-thumbnail [exercise]="exercise"></app-exercise-thumbnail>
      </ion-thumbnail>
    </div>



    </ion-item>
  </ion-list>

  <ng-template #skeleton>
    <ion-list>
      <ion-item *ngFor="let item of [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]">
        <ion-thumbnail slot="start">
          <ion-skeleton-text [animated]="true"></ion-skeleton-text>
        </ion-thumbnail>
        <ion-label>
          <h3>
            <ion-skeleton-text [animated]="true" style="width: 80%;"></ion-skeleton-text>
          </h3>
          <p>
            <ion-skeleton-text [animated]="true" style="width: 60%;"></ion-skeleton-text>
          </p>
        </ion-label>
      </ion-item>
    </ion-list>
  </ng-template>
</ion-content>
